import "../chunk-7B52C2XE.js";
const EVENT_PREFIX = "para";
var ParaEvent = ((ParaEvent2) => {
  ParaEvent2["LOGIN_EVENT"] = `${EVENT_PREFIX}Login`;
  ParaEvent2["ACCOUNT_CREATION_EVENT"] = `${EVENT_PREFIX}AccountCreation`;
  ParaEvent2["ACCOUNT_SETUP_EVENT"] = `${EVENT_PREFIX}AccountSetup`;
  ParaEvent2["LOGOUT_EVENT"] = `${EVENT_PREFIX}Logout`;
  ParaEvent2["SIGN_MESSAGE_EVENT"] = `${EVENT_PREFIX}SignMessage`;
  ParaEvent2["SIGN_TRANSACTION_EVENT"] = `${EVENT_PREFIX}SignTransaction`;
  ParaEvent2["EXTERNAL_WALLET_CHANGE_EVENT"] = `${EVENT_PREFIX}ExternalWalletChange`;
  ParaEvent2["WALLETS_CHANGE_EVENT"] = `${EVENT_PREFIX}WalletsChange`;
  ParaEvent2["WALLET_CREATED"] = `${EVENT_PREFIX}WalletCreated`;
  ParaEvent2["PREGEN_WALLET_CLAIMED"] = `${EVENT_PREFIX}PregenWalletClaimed`;
  return ParaEvent2;
})(ParaEvent || {});
export {
  ParaEvent
};
